export const managerTransactionDaysOptions = [
  { key: 3, text: "3 days", value: 3 },
  { key: 7, text: "7 days", value: 7 },
  { key: 14, text: "14 days", value: 14 },
  { key: 31, text: "31 days", value: 31 },
  { key: 60, text: "60 days", value: 60 },
  { key: 90, text: "90 days", value: 90 },
];

export const managerInitialLoginPageValues = {
  CALENDAR: "calendarManager",
  TRANSACTIONS: "transactionsManager",
  AGENTS: "overviewManager",
  BROKERAGE: "brokerageManager",
};

function hasCalendarAccess(profile) {
  return profile?.managerAccess?.hasAccessToCalendarDashboard === true;
}

function hasBrokerageAccess(profile) {
  return (
    profile?.role === "manager" ||
    profile?.managerAccess?.hasAccessToBrokerageDashboard === true
  );
}

export function getManagerInitialLoginOptions(profile) {
  const options = [];

  if (hasCalendarAccess(profile)) {
    options.push({
      key: managerInitialLoginPageValues.CALENDAR,
      text: "Calendar",
      value: managerInitialLoginPageValues.CALENDAR,
    });
  }

  options.push(
    {
      key: managerInitialLoginPageValues.TRANSACTIONS,
      text: "Transactions",
      value: managerInitialLoginPageValues.TRANSACTIONS,
    },
    {
      key: managerInitialLoginPageValues.AGENTS,
      text: "Agents",
      value: managerInitialLoginPageValues.AGENTS,
    }
  );

  if (hasBrokerageAccess(profile)) {
    options.push({
      key: managerInitialLoginPageValues.BROKERAGE,
      text: "Brokerage",
      value: managerInitialLoginPageValues.BROKERAGE,
    });
  }

  return options;
}

export function getManagerInitialLoginPage(profile) {
  const savedPage = profile?.managerPreferences?.initialLoginPage;
  const allowedPages = getManagerInitialLoginOptions(profile).map(
    (option) => option.value
  );

  if (savedPage && allowedPages.includes(savedPage)) return savedPage;

  return hasCalendarAccess(profile)
    ? managerInitialLoginPageValues.CALENDAR
    : managerInitialLoginPageValues.AGENTS;
}

export function getManagerTransactionDefaultDays(profile, preferenceKey) {
  return (
    profile?.managerPreferences?.transactionDefaultDays?.[preferenceKey] || 7
  );
}